if (!String.prototype.ucfirst) {
    String.prototype.ucfirst = function () {
        let str = this;
        if (str.length) {
            str = str.charAt(0).toUpperCase() + str.slice(1);
        }
        return str;
    };
}

if (!String.prototype.ucwords) {
    String.prototype.ucwords = function () {
        let str = this;
        str = str.toLowerCase().replace(/^[\u00C0-\u1FFF\u2C00-\uD7FF\w]|\s[\u00C0-\u1FFF\u2C00-\uD7FF\w]/g, function(letter) {
            return letter.toUpperCase();
        });

        return str
    };
}

if(!String.prototype.trim) {
    String.prototype.trim = function () {
        return this.replace(/^\s+|\s+$/g,'');
    };
}
